import { Inject, Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { ApplicationDto } from '../model/business/application/ApplicationDto';
import { Observable, of } from 'rxjs';
import { RequestOptions } from '../model/RequestOptions';
import { CountryDto } from '../model/business/application/CountryDto';
import { map, tap } from 'rxjs/operators';
import { LocationDto } from '../model/LocationDto';
import { MainOccupationDto, OccupationServiceResponse } from '../model/business/application/MainOccupationDto';
import { environment } from '../../environments/environment';
import { ApplicationTransactionDto } from '../model/business/application/ApplicationTransactionDto';
import { HttpClient } from '@angular/common/http';
import { ApplicationGGDto } from '../model/business/application/ApplicationGGDto';
import { QuotationRequestFailedKnowledgeTestDto } from '../model/business/calculation/QuotationRequestDto';

@Injectable({
  providedIn: 'root',
})
export class ApplicationApiService {
  constructor(
    private httpService: HttpService,
    private httpClient: HttpClient,
    @Inject('API_URL') private baseUrl: string,
  ) { }

  countries = [];

  sendApplicationRequest(model: ApplicationTransactionDto): Observable<ApplicationDto> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    requestOptions.ShowSuccess = true;
    requestOptions.HandleGenericError = true;

    return this.httpService.post<ApplicationDto>(
      'application/submitApplication',
      model,
      null,
      requestOptions
    );
  }

  sendGGApplicationRequest(model: ApplicationTransactionDto): Observable<ApplicationGGDto> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    requestOptions.ShowSuccess = true;
    requestOptions.HandleGenericError = true;

    return this.httpService.post<ApplicationGGDto>(
      'application/submitApplication',
      model,
      null,
      requestOptions
    );
  }

  getCountries(): Observable<string[]> {
    if (this.countries.length > 0) {
      return of(this.countries);
    }
    return this.httpService.get('application/countries').pipe(
      map((values: CountryDto[]) => values.map((v) => v.countryCode)),
      tap((values) => (this.countries = values))
    );
  }

  getLocation(zipCode = '', houseNumber: string): Observable<LocationDto> {
    return this.httpService.get('application/getLocation', {
      zipCode: zipCode.toUpperCase(),
      houseNumber,
    });
  }

  getOccupations(product): Observable<MainOccupationDto[]> {
    return this.httpService.get(`application/occupations?productType=${product}`);
  }

  getReceiptPDF(transactionId = ''): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}application/transaction-receipt`, {
      params: {
        transactionId,
      },
      responseType: 'blob',
    });
  }

  sendQuotationRequest(model: QuotationRequestFailedKnowledgeTestDto): Observable<Array<any>> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    requestOptions.ShowSuccess = false;
    requestOptions.HandleGenericError = true;

    return this.httpService.post<Array<any>>(
      'quotation/sendQuotation',
      model,
      null,
      requestOptions
    );
  }
}
